/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import SubscriptionCenterService from 'cio/services/subscription-center';
import { inject as service } from '@ember/service';
import CampaignModel from 'cio/models/campaign';

interface ActionsOverridingCampaignSettingsArgs {
  actions: ActionModel[];
  actionKey?: 'sendToUnsubscribed' | 'sendToSubscribed' | number | string;
  campaign: CampaignModel;
}

export default class ActionsOverridingCampaignSettings extends Component<ActionsOverridingCampaignSettingsArgs> {
  @service subscriptionCenter!: SubscriptionCenterService;

  constructor(owner: unknown, args: ActionsOverridingCampaignSettingsArgs) {
    super(owner, args);
    this.subscriptionCenter.initializeTask.perform();
  }

  get topic() {
    if (!this.subscriptionCenter.initialized) {
      return;
    }
    return this.subscriptionCenter.topics.find((topic) => topic.id === this.args.actionKey);
  }

  get sendingToUnsubscribed() {
    return this.args.actionKey === 'sendToUnsubscribed';
  }

  get sendingToSubscribed() {
    return this.args.actionKey === 'sendToSubscribed';
  }

  get sendingBasedOnTopic() {
    let { actionKey } = this.args;
    return this.topic != null && actionKey !== 'sendToUnsubscribed' && actionKey !== 'sendToSubscribed';
  }

  get invalidAudience() {
    return this.subscriptionCenter.enabled && this.sendingToSubscribed;
  }
}
